export default __webpack_public_path__ + "static/media/Lean, Bloody Wings.e7fb5d39.png";